import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AuthContext from "../context/Authcontext";
import menu from "../assets/menu.png";
const Forum = () => {
  const { id, id2 } = useParams();
  const navigate = useNavigate();
  const [room, setroom] = useState({ name: "", description: "" });
  const [messages, setmessages] = useState([]);
  const [message, setmessage] = useState("");
  const [refresh, setRefresh] = useState(false); // new state variable
  const [errorMessage, setErrorMessage] = useState(""); // new state variable for error message

  const { contextData } = useContext(AuthContext);

  useEffect(() => {
    userisinforums();
    getroom();
    getmessages();
  }, []);
  useEffect(() => {
    getmessages();
  }, [refresh]);

  const getroom = async () => {
    let responce;
    try {
      responce = await axios.get(
        `https://pfebackend-zbz0.onrender.com/api/room/${id2}/`
      );
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setErrorMessage(
          "Sorry, there was a problem with the server. Please try again later."
        );
      }
      return;
    }

    setroom(responce.data);
  };

  const getmessages = async () => {
    let responce;
    try {
      responce = await axios.get(
        `https://pfebackend-zbz0.onrender.com/api/room/massages/${id2}/`
      );
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setErrorMessage(
          "Sorry, there was a problem with the server. Please try again later."
        );
      }
      return;
    }
    setmessages(responce.data);
  };

  const handleChange = (e) => {
    setmessage(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (message !== "") {
      let responce;
      try {
        responce = await axios.post(
          "https://pfebackend-zbz0.onrender.com/api/room/massages/add/",
          { body: message, room: id2 },
          {
            headers: {
              Authorization: `Bearer ${contextData.authTokens.access}`,
            },
          }
        );
      } catch (error) {
        if (error.response && error.response.status === 500) {
          setErrorMessage(
            "Sorry, there was a problem with the server. Please try again later."
          );
        }
        return;
      }
    }

    setRefresh(!refresh);

    setmessage("");
  };

  const handeldelete = async (e) => {
    let responce;
    try {
      responce = await axios.delete(
        `https://pfebackend-zbz0.onrender.com/api/message/delete/${e.id}/`
      );
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setErrorMessage(
          "Sorry, there was a problem with the server. Please try again later."
        );
      }
      return;
    }
    setRefresh(!refresh);
  };

  const timeelapsed = (message) => {
    // Step 1: Convert updated attribute to a JavaScript Date object
    const updatedDate = new Date(message.updated);

    // Step 2: Get the current date and time
    const currentDate = new Date();

    // Step 3: Calculate time difference in minutes
    const timeDifferenceInMinutes = Math.floor(
      (currentDate - updatedDate) / (1000 * 60) // Convert to minutes
    );

    // Step 4: Calculate time difference in hours, days, weeks, and years
    let timeAgo = "";
    if (timeDifferenceInMinutes < 1) {
      timeAgo = "Just now";
    } else if (timeDifferenceInMinutes < 60) {
      timeAgo = `${timeDifferenceInMinutes} minutes ago`;
    } else if (timeDifferenceInMinutes < 1440) {
      // 1440 minutes = 1 day (60 minutes/hour * 24 hours/day)
      const hours = Math.floor(timeDifferenceInMinutes / 60);
      timeAgo = `${hours} hour${hours === 1 ? "" : "s"} ago`;
    } else if (timeDifferenceInMinutes < 10080) {
      // 10080 minutes = 1 week (60 minutes/hour * 24 hours/day * 7 days/week)
      const days = Math.floor(timeDifferenceInMinutes / 1440);
      timeAgo = `${days} day${days === 1 ? "" : "s"} ago`;
    } else if (timeDifferenceInMinutes < 525600) {
      // 525600 minutes = 1 year (60 minutes/hour * 24 hours/day * 365 days/year)
      const weeks = Math.floor(timeDifferenceInMinutes / 10080);
      timeAgo = `${weeks} week${weeks === 1 ? "" : "s"} ago`;
    } else {
      const years = Math.floor(timeDifferenceInMinutes / 525600);
      timeAgo = `${years} year${years === 1 ? "" : "s"} ago`;
    }

    return <p>{timeAgo}</p>;
  };

  const handeldeleteroom = async () => {
    let responce;
    try {
      responce = await axios.delete(
        `https://pfebackend-zbz0.onrender.com/api/room/delete/${id2}/`
      );
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setErrorMessage(
          "Sorry, there was a problem with the server. Please try again later."
        );
      }
      return;
    }
    navigate(`/formation/${id}/rooms`);
  };

  const userisinforums = async () => {
    let responce;
    if (contextData.user) {
      try {
        responce = await axios.get(
          `https://pfebackend-zbz0.onrender.com/api/user/formation/${id}/`,
          {
            headers: {
              Authorization: `Bearer ${contextData.authTokens.access}`,
            },
          }
        );
      } catch (error) {
        if (error.response && error.response.status === 500) {
          setErrorMessage(
            "Sorry, there was a problem with the server. Please try again later."
          );
        }
        return;
      }
      if (!responce.data) {
        navigate("/notallowed");
      }
    } else {
      navigate("/notallowed");
    }
  };

  const handelshowownerprofile = (e) => {
    navigate(`/profile/${e}/`);
  };

  return (
    <div className="forum--container">
      <div className="room-reader">
        {errorMessage && (
          <div className=" erroremailexiste">{errorMessage}</div>
        )}
        <h2>{room.name}</h2>

        <div className="dropdown">
          <div
            className="dropbtn "
            style={{ borderRadius: "7px", color: "white" }}
          >
            <img src={menu} alt="" />
          </div>
          <div className="dropdown-content">
            {contextData.user && room.host === contextData.user.id && (
              <div className="dropdown-item" onClick={handeldeleteroom}>
                delete room
              </div>
            )}
          </div>
        </div>
      </div>

      <p className="room-description">{room.description}</p>

      <h3 className="message-title">Messages</h3>
      <form onSubmit={handleSubmit}>
        <input
          className="message-input-forum"
          type="text"
          placeholder="write your message"
          value={message}
          onChange={handleChange}
        />
      </form>
      {messages.map((e, i) => (
        <div className="message" key={i}>
          <h5
            style={{ cursor: "pointer" }}
            onClick={() => handelshowownerprofile(e.owner_id)}
          >
            {e.owner}
          </h5>
          {timeelapsed(e)}
          <p className="room-message">{e.body}</p>
          {e.owner_id === contextData.user.id ? (
            <button onClick={() => handeldelete(e)}>delete</button>
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default Forum;
